import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const seaTable = defineConnector({
  identifier: "seaTable",
  name: "SeaTable",
  tagLine: "Spreadsheet database",
  logo,
  protocol: "http",
  tags: ["data"],
  defaultUrlPattern: () => "https://cloud\\.seatable\\.io/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        scheme: "Token",
        value: app.secret.token,
      },
    ]),
  steps: [
    {
      title: "Get your API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [SeaTable](https://cloud.seatable.io/), open a base and go to the **three-dot menu → Advanced → API Token** to generate a token.",
        },
      ],
    },
    {
      title: "Enter your token",
      items: [
        {
          kind: "input",
          label: "Token",
          required: true,
          target: { kind: "secrets", field: "token" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://cloud.seatable.io/api/v2.1/dtable/app-access-token/",
  },
});
